// MainTab wrapper of the content grid
// Items data is derived from the MainTabs endpoint

import {
  ContentGrid,
  ContentGridProps,
} from "@/components/Content/ContentGrid.tsx";
import { useFullItemsMainTab } from "../hooks/useFullItemsMainTab.tsx";

type MainTabGridProps = Omit<ContentGridProps, "fullItems">;

export const MainTabGrid = ({ collection, ...props }: MainTabGridProps) => {
  const { fullItems } = useFullItemsMainTab(collection.Items);
  return (
    <ContentGrid {...props} collection={collection} fullItems={fullItems} />
  );
};
